/* eslint-disable no-undef */
import ywk from './ywk.js'
import axios from 'axios'

/**
 * 验证集成登录
 * @param {*Function} success
 * @param {*Function} fail
 */
const ssoLogin = (success = () => { }, fail = () => { }) => {
  let url = `${PASSPORT_DOMAIN}/sso/login`
  axios.defaults.withCredentials = true
  axios.get(url, {}, {
    headers: { 'crossDomain': true }
  }).then((respon) => {
    let data = respon.data
    if (data.error_code === 0) {
      ywk.postJson('/api/v2/user/signin/sso', { ticket: data.ticket }).then((resp) => {
        if (resp.error_code !== 0) {
          fail()
        } else {
          success()
        }
      })
    } else {
      fail()
    }
  })
}

/**
 * 获取用户信息
 * @param {*Function} success
 * @param {*Function} fail
 * @param {*Function} ssosuccess
 * @param {*Function} ssofail
 */
export const profileFn = (success = () => { }, fail = () => { }, ssosuccess = () => { }, ssofail = () => { }) => {
  ywk.getJson('/api/user/profile').then((res) => {
    window.profileLoading = false
    if (res.error_code !== 0) {
      fail()
      if (window.location.hostname !== 'localhost') {
        ssoLogin(ssosuccess, ssofail)
      }
    } else {
      success(res)
    }
  })
}

/**
 * 跳转登录
 */
export const goLogin = () => {
  let url = `${PASSPORT_DOMAIN}/signin`
  window.location.href = `${url}?return_url=${encodeURIComponent(window.location.href)}`
}
